<template>
  <div>
    <h3 class="c-blue-dark mb-24 title">
      {{ countryName }} - kiedy na wakacje?
    </h3>
    <ul>
      <template v-for="(textLine, idx) in meteoDesc.punkty">
        <li class="mb-12" :key="idx">{{ textLine }}</li>
      </template>
    </ul>
    <p v-if="meteoDesc.opis.length">{{ meteoDesc.opis }}</p>
  </div>
</template>

<script>
export default {
  name: "when-to-go",
  props: {
    countryName: String,
    meteoDesc: [Array, Object]
  },
  data: () => ({}),
  methods: {}
};
</script>
